// src/utils/textLang.js
//
// The lang attribute for a piece of user-written text, from the script it
// contains: 'ml' for Malayalam (U+0D00–U+0D7F), 'hi' for Devanagari
// (U+0900–U+097F), otherwise undefined so English text gets no attribute.
// lang lets the browser pick script-appropriate line breaking and shaping.

const MALAYALAM = /[ഀ-ൿ]/;
const DEVANAGARI = /[ऀ-ॿ]/;

export default function textLang(text) {
  if (!text) return undefined;
  if (MALAYALAM.test(text)) return 'ml';
  if (DEVANAGARI.test(text)) return 'hi';
  return undefined;
}
